<div (visibilityChange)="onVisibilityChanged($event)" [intersectionDebounce]="0"
     appIntersectionObserver class="list-item-min-height">
  <div class="lst-itm-card">
    @if (compData?.container?.selectedProduct) {
      <app-b2b-desktop-promotion1-strip
        [src]="compData?.container?.source"
      ></app-b2b-desktop-promotion1-strip>
    }
    <div [ngClass]="{
      'premium-property':
        compData?.container?.starRating > 3 || compData?.container?.filters?.isPremium
      }"
         class="list-property-card">
      <div [ngClass]="{ 'sold-out-item': compData?.container?.isSoldOut }" class="property-card">
        @if (compData?.container?.longStripPromotion) {
          <app-b2b-desktop-promotion2-strip
            [promotion]="compData?.container?.longStripPromotion"
          ></app-b2b-desktop-promotion2-strip>
        }
        <div class="property-detail">
          <div class="image-container">
            <div class="dynamic-img">
              <img #image
                   (click)="onCardClick(null)"
                   (error)="image.src = placeHolderImage + '?format=webp&quality=80&width=287&height=190'"
                   [alt]="compData?.container?.image?.alt"
                   [ngSrc]="pImage$ | async"
                   [priority]="compData?.index === 0"
                   height="190"
                   width="287"
              />
              @if (compData?.container?.pc1?.propertyPromotion?.listPageImageOverlay; as listPageImageOverlay) {
                <div class="dynamic-bg"
                     [ngStyle]="{ 'background': 'linear-gradient(45deg, rgb(26, 87, 152), rgb(82, 181, 255))','color': 'white' }"
                >
                  {{ listPageImageOverlay }}
                </div>
              }
              <!-- New property tag -->
              @if ((compData?.container?.filters?.isNewProperty | withInDateRange: 30) && (compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY)) {
                <div class="new-property">
                  @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                    <img
                      [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/new-property.png?format=webp&quality=90'"
                      class="tag-img"
                      alt="new-property"
                      loading="lazy"
                      width="50"
                      height="60"/>
                  }
                </div>
              }

              <!--@if (compData?.container?.isCouplePackage) {
                <div class="val-bg">
                  <img
                    [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/couple-badge.png?format=webp&quality=80&width=179&height=179'"
                    alt="valentine-badge" loading="lazy"
                    width="179" height="179">
                </div>
              }-->

            </div>
            <div class="all-img-wrap">
              @for (image of compData?.container?.promotionImages
                | slice: 1 : 5; track
                image; let last = $last) {
                <div class="img-sec">
                  <img [ngSrc]="image?.path + '?format=webp&quality=100&width=64&height=50'"
                       width="64"
                       height="50"
                       loading="lazy"
                       [alt]="image?.alt"
                       #imageEle
                       (mouseenter)="changeSelectedImage(image)"
                       (error)="imageEle.src = placeHolderImage + '?format=webp&quality=100&width=64&height=50'"
                  />
                  @if (last) {
                    <div class="view-all">
                      <span (click)="openImageGallery()">View all</span>
                    </div>
                  }
                </div>
              }
            </div>
            @if (compData?.container?.promotionImages?.length > 0) {
              <div class="see-all-wrap" (click)="openImageGallery()">See All Images</div>
            }
          </div>
          <div class="body-container">
            <div class="first-sec">

              <div class="flex-container ion-align-items-center ion-justify-content-between hdr-wrap">
                <div>
                  <div class="rt-box">
                    <div>
                      @if (compData?.container?.starRatingConfig?.filledStars?.length > 0) {
                        <div class="stars-section">
                          <!--filled star-->
                          @for (star of compData?.container?.starRatingConfig?.filledStars; track star; let index = $index) {
                            &#9733;
                          }
                        </div>
                      }
                    </div>
                    @if (compData?.container?.isB2bCertified) {
                      <div class="certified-wrap dsp-badge" (click)="toggleCertified($event)"
                           [ngStyle]="{'background': 'linear-gradient(95.1deg, rgb(1, 5, 103) 0%, rgb(26, 85, 155) 100%)'}">
                        <div class="certified-b-img">
                          <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/bag2bag-certified.png'"
                               alt="bag2bag-certified" width="100" height="100" loading="lazy">
                        </div>
                        <span class="badge-text" [ngStyle]="{'color': '#ffffff'}">Certified</span>
                        @if (isVisible) {
                          <div class="cerInfo" #certifiedPopup (click)="$event.stopPropagation()">
                            <div class="imgBlk">
                              <div class="cerImg">
                                <img
                                  [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/bag2bag-certified.png'"
                                  alt="bag2bag-certified" width="100" height="100" loading="lazy">
                              </div>
                              <div class="cerTitle">
                                {{ compData?.container?.certifiedContainer?.title }}
                                <!--Top Rated Affordable Properties-->
                              </div>
                            </div>
                            <div class="cerNotes">
                              <div class="desc"
                                   [innerHTML]="compData?.container?.certifiedContainer?.description | safe:'html'"></div>
                              <div class="flex-container ion-align-items-center ion-justify-content-end link">
                                <a [routerLink]="compData?.container?.certifiedContainer?.navigationURL"
                                   target="_blank">Learn
                                  More</a>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="rating-n-assured">
                  @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
                    <div class="rating-container">
                      <div class="rating">
                        <span>{{ compData?.container?.ratingAndReviewConfig?.rating | number: '1.1-1' }}</span>
                        <span class="filled">&#9733;</span>
                      </div>
                      @if (compData?.container?.ratingAndReviewConfig?.votes > 0) {
                        <div class="votes-count">
                          ({{ compData?.container?.ratingAndReviewConfig?.votes + " " + compData?.container?.ratingAndReviewConfig?.sRatingLabel }}
                          )
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="hotel-title">
                <div class="title-wrap">
                  <div class="font-bold title">
                    <div (click)="onCardClick(null); fireGoogleEvent();">
                      @if (compData?.container?.seoNavigationUrl) {
                        <a
                          [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                          class="pro-nme"
                          href="{{ hostWebsite + compData?.container?.seoNavigationUrl }}"
                          onclick="return false;"
                          target="_blank">
                          {{ compData?.container?.displayName | titlecase }}
                        </a>
                      } @else {
                        <a
                          [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                          class="pro-nme"
                          href="javascript:void(0)"
                        >
                          {{ compData?.container?.displayName | titlecase }}
                        </a>
                      }

                    </div>
                  </div>
                </div>
              </div>


              <!--<div class="flex-container ion-align-items-start ion-justify-content-between">
                <div class="hotel-title">
                  <div class="title-wrap">
                    <div class="font-bold title">
                      <div (click)="onCardClick(null); fireGoogleEvent();">
                        @if (compData?.container?.seoNavigationUrl) {
                          <a
                            [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                            class="pro-nme"
                            href="{{ hostWebsite + compData?.container?.seoNavigationUrl }}"
                            onclick="return false;"
                            target="_blank">
                            {{ compData?.container?.displayName | titlecase }}
                          </a>
                        } @else {
                          <a
                            [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                            class="pro-nme"
                            href="javascript:void(0)"
                          >
                            {{ compData?.container?.displayName | titlecase }}
                          </a>
                        }

                      </div>
                    </div>

                    @if (compData?.container?.starRatingConfig?.filledStars?.length > 0) {
                      <div class="stars-section">
                        &lt;!&ndash;filled star&ndash;&gt;
                        @for (star of compData?.container?.starRatingConfig?.filledStars; track star; let index = $index) {
                          &#9733;
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="rating-n-assured">
                  @if (compData?.container?.isB2bCertified) {
                    <div>
                      <div class="certified-img">
                        <img ngSrc="https://i.postimg.cc/GpH9BjGv/certified-badge-new.png"
                             alt="certified-badge" width="100" height="100" loading="lazy">
                      </div>
                    </div>
                  }
                  @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
                    <div class="rating-container">
                      <div class="rating">
                        <span>{{ compData?.container?.ratingAndReviewConfig?.rating | number: '1.1-1' }}</span>
                        <span class="filled">&#9733;</span>
                      </div>
                      @if (compData?.container?.ratingAndReviewConfig?.votes > 0) {
                        <div class="votes-count">
                          ({{ compData?.container?.ratingAndReviewConfig?.votes + " " + compData?.container?.ratingAndReviewConfig?.sRatingLabel }}
                          )
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>-->


              <div class="dsc-km-box">
                @if (compData?.container?.description) {
                  <span class="description">
                    <!--app-text-clamp-shell
                      [config]="{
                    data: (compData?.container?.description | titlecase),
                    row: 2
                  }"
                    >
                    </app-text-clamp-shell>-->
                    {{ compData?.container?.description | titlecase }}
                  </span>
                }
                @if (compData?.container?.distanceFromLocation) {
                  <span class="just-km">
                    {{ compData?.container?.distanceFromLocation }}
                  </span>
                }
              </div>
              @if (compData?.container?.vendorOfferings) {
                <div>
                  @for (vendorOffering of compData?.container?.vendorOfferings | slice:0: 3; track vendorOffering; let index = $index; ) {
                    <div class="venOfr">
                      <div>
                        <svg width="14px" height="14px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                             fill="none" stroke="#179b4c" stroke-linecap="round" stroke-linejoin="round"
                             stroke-width="1.5">
                          <polyline points="2.75 8.75,6.25 12.25,13.25 4.75"/>
                        </svg>
                      </div>
                      <div class="title">
                        {{ vendorOffering?.title }}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>

            <!-- Pre food booking tag starts -->
            @if (compData?.container?.filters?.preBookFood) {
              <div class="pre-book">
                <div class="food-img">
                  <img
                    [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/pre-book-food.png' + '?format=webp&quality=80'"
                    alt="food" width="16" height="16">
                </div>
                <div class="title">Pre book food</div>
              </div>
            }
            <!-- Pre food booking tag ends -->

            <!-- badges section start -->
            @if (compData?.container?.badges?.length > 0) {
              <div class="badge-container" (click)="onCardClick(null)"
                   [ngClass]="{'short-badges': compData?.container?.type === 'SHORTSTAY'}">
                @for (badge of compData?.container?.badges; track badge) {
                  @if (badge?.text | isNotEmpty) {
                    <div class="badge">
                      <div class="ion-badge-info flex-container ion-align-items-start">
                        <div class="ico-wrap">
                          <span class="tick-icon"></span>
                        </div>
                      </div>
                      <div class="title">{{ badge?.text | titlecase }}</div>
                    </div>
                  }
                }
              </div>
            }
            <!-- badges section ends -->

            <!-- Offer 1 start here -->
            @if (compData?.container?.pc1?.propertyPromotion?.pc1; as pc1Text) {
              <div class="pty-hls">
                <div>
                  <div class="pty-hls-img">
                    <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/star-offer-icon.png'"
                         alt="stars"
                         width="64" height="64">
                  </div>
                </div>
                <div>
                  <div class="desc">
                    {{ pc1Text }}
                  </div>
                </div>
              </div>
            }
            <!-- Offer 1 ends here -->

            <!-- Offer 2 start here -->
            @if (compData?.container?.pc1?.propertyPromotion?.pc2; as pc2Text) {
              <div class="pty-s-hls">
                <div>
                  <div class="pty-s-hls-img">
                    <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/flash-offer-icon.png'"
                         alt="stars"
                         width="64" height="64">
                  </div>
                </div>
                <div>
                  <div class="desc">{{ pc2Text }}</div>
                </div>
              </div>
            }
            <!-- Offer 2 ends here -->

            <!-- Active hours start -->
            @if (compData?.container?.hourOptions?.length > 0) {
              <div class="scroll-hours">
                <p class="hours-title">All Available Hours</p>
                <app-b2b-drag-scroll
                  [config]="swiperConfig"
                  [dragToId]="
                    compData?.container?.uid +
                    '-hour-' +
                    compData?.container?.selectedHour
                  "
                >
                  @for (hourOption of compData?.container?.hourOptions; track hourOption) {
                    <app-b2b-drag-scroll-item [config]="swiperConfig">
                      <div class="hour-options">
                        <div class="hours-selection"
                             id="{{ compData?.container?.uid }}-hour-{{
                            hourOption?.hour
                          }}"
                             [ngClass]="{
                            'selected-hour': hourOption?.selected,
                            'deactivated-hour': !hourOption?.active
                          }">
                          @if (hourOption?.active) {
                            <div class="hourly-details active" (click)="onSelectHour(hourOption)">
                              <div class="hour">{{ hourOption?.display }}</div>
                              <div class="rate">₹ {{ hourOption?.rate }}</div>
                              <!--@if (!hourOption?.selected) {
                                <div class="select-btn"
                                     (click)="onSelectHour(hourOption)">
                                  Select
                                </div>
                              }
                              @if (hourOption?.selected) {
                                <div class="selected"
                                     (click)="onSelectHour(hourOption)">
                                  Selected
                                </div>
                              }-->
                            </div>
                          }
                          @if (!hourOption?.active) {
                            <div class="not-active">
                              <div class="hour">{{ hourOption?.display }}</div>
                              <div class="rate">Not Available</div>
                            </div>
                          }
                        </div>
                      </div>
                    </app-b2b-drag-scroll-item>
                  }
                </app-b2b-drag-scroll>
              </div>
            }
            <!-- Active hours end -->


          </div>
          <!--<div class="border-new"></div>-->
          <div class="price-container">
            <div class="price-detail">
              @if (compData?.container?.priceDetail) {
                <ng-container
                  *ngTemplateOutlet="discountedRateTemplate"
                ></ng-container>
                <div class="btn-ftr">
                  <ng-container
                    *ngTemplateOutlet="buttonsTemplate"
                  ></ng-container>
                </div>
              }
            </div>
          </div>

          <div class="premium-wrap">
            <!-- Premium tag -->
            @if (compData?.container?.starRating > 3 || compData?.container?.filters?.isPremium) {
              <div class="premium-property">
                @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                  <!--<img
                    [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/premium.png?format=webp&quality=90'"
                    class="premium-img"
                    alt="premium"
                    loading="lazy"
                    style="margin: auto"
                    width="100"
                    height="100"
                  />-->
                  <p class="ribbon">
                    <span class="text">
                      <strong class="bold">Premium</strong></span>
                  </p>
                }
              </div>
            }
          </div>
        </div>
        @if (compData?.container?.pc1?.textList?.length > 0) {
          <div class="ofr-bnr">
            @for (offer of compData?.container?.pc1?.textList; track offer) {
              <div class="ofr-txt" [innerHTML]="offer | safe: 'html'">
              </div>
            }

          </div>
        }
      </div>
    </div>
  </div>
</div>


@if (compData?.container?.hotelListSchema && compData?.container?.hotelListSchema?.url) {
  <div class="hidden">
    <div itemscope="" itemtype="http://schema.org/Hotel">
              <span itemprop="name">{{
                  compData?.container?.hotelListSchema?.name
                }}</span>
      @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
        <div
          itemprop="aggregateRating"
          itemscope=""
          itemtype="http://schema.org/AggregateRating"
        >
          <meta
            itemprop="ratingValue"
            content="{{
          compData?.container?.ratingAndReviewConfig?.rating
        }}"
          />
          <meta itemprop="worstRating" content="1"/>
          <meta
            itemprop="reviewCount"
            content="{{
          compData?.container?.ratingAndReviewConfig?.votes
        }}"
          />
          <meta itemprop="bestRating" content="5"/>
        </div>
      }
      <div
        itemprop="address"
        itemscope=""
        itemtype="http://schema.org/PostalAddress"
      >
                    <span itemprop="addressLocality">
                      {{
                        compData?.container?.hotelListSchema?.address?.addressLocality
                      }} </span>
        <span itemprop="addressRegion">{{
            compData?.container?.hotelListSchema?.address?.addressRegion
          }}</span>
        <span itemprop="addressCountry">{{
            compData?.container?.hotelListSchema?.address?.addressCountry
          }}</span>
        <span itemprop="streetAddress">{{
            compData?.container?.hotelListSchema?.address?.streetAddress
          }}</span>
        <span itemprop="postalCode">{{ compData?.container?.hotelListSchema?.address?.postalCode }}</span>
      </div>
      <meta itemprop="priceRange" content="{{  compData?.container?.hotelListSchema?.priceRange }}"/>
      <meta
        itemprop="telephone"
        content="{{ compData?.container?.hotelListSchema?.telephone }}"
      />
      <meta
        itemprop="url"
        content="{{ compData?.container?.hotelListSchema?.url }}"
      />
      <meta
        itemprop="email"
        content="{{ compData?.container?.hotelListSchema?.email }}"
      />
      <meta
        itemprop="image"
        content="{{ compData?.container?.hotelListSchema?.image }}"
      />
      <div
        itemprop="geo"
        itemscope=""
        itemtype="http://schema.org/GeoCoordinates"
      >
        <meta
          itemprop="latitude"
          content="{{ compData?.container?.hotelListSchema?.geo?.latitude }}"
        />
        <meta
          itemprop="longitude"
          content="{{ compData?.container?.hotelListSchema?.geo?.longitude }}"
        />
      </div>
    </div>
  </div>
}

<ng-template #buttonsTemplate>
  @if (compData?.container?.promotionData?.inventoryPromotionCard?.title) {
    <div class="mem-cd-ttl">
      {{ compData?.container?.promotionData?.inventoryPromotionCard?.title }}
    </div>
  }

  <div class="button-item book-now-btn">
    <div class="buttons-container">
      @if (compData?.container?.isEnquiry) {
        <button class="bk-btn" (click)="enquriyNow()">Enquire Now</button>
      }
      @if (!compData?.container?.notBookable) {
        <button class="bk-btn" (click)="onCardClick(null)">Book Now</button>
      }
    </div>
  </div>
</ng-template>


<ng-template #discountedRateTemplate>
  <div class="discount-rate-cls">
    <div class="price-contain">
      <div class="discounted-price-section">

        <div class="header">
          <div class="lft-prc">
            @if (compData?.container?.pc1?.propertyPromotion?.offerPromotionText; as offerPromotionText) {
              <div class="vdr-ofr">
                <div class="ofr-txt">{{ offerPromotionText }}</div>
              </div>
            }
            @if (!compData?.container?.disableBookNow) {
              @if (compData?.container?.priceDetail?.rackRate > 0) {
                <div class="rk-rte">
                  <span class="rk-rte-dis">₹{{ compData?.container?.priceDetail?.rackRate }}</span>
                  @if (compData?.container?.priceDetail?.totalListPageDiscountPercentage > 0) {
                    <span class="tot-dis-wrp">
                      {{ compData?.container?.newCartDescription?.presentationData?.listPageDiscountInfo }}
                    </span>
                  }
                </div>
              }
              @if (compData?.container?.priceDetail?.listPageOfferedRate > 0) {
                <div class="off-prc">
                  @if (compData?.container?.newCartDescription?.priceInfo) {
                    <span>{{ compData?.container?.newCartDescription?.priceInfo }}</span>
                  }
                  <span>
                    ₹{{ compData?.container?.priceDetail?.listPageOfferedRate }}
                  </span>
                  @if (compData?.container?.newCartDescription?.presentationData?.listRoomInfo) {
                    <div class="rvw-sec">
                      <span class="rm-info">
                        {{ compData?.container?.newCartDescription?.presentationData?.listRoomInfo }}
                      </span>
                      @if (compData?.container?.newCartDescription?.presentationData?.nightInfo) {
                        <span class="nit-info">
                          {{ compData?.container?.newCartDescription?.presentationData?.nightInfo }}
                        </span>
                      }
                      @if (compData?.container?.newCartDescription?.presentationData?.hourInfo) {
                        <span class="hr-info">
                          {{ compData?.container?.newCartDescription?.presentationData?.hourInfo }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }
              @if (compData?.container?.newCartDescription?.taxInfo) {
                <div class="tax-info">
                  ({{ compData?.container?.newCartDescription?.taxInfo }})
                </div>
              }
            }
          </div>

          <div class="icon-wrap">
            <div (click)="toggleFavorite()" [class.fav-btn]="isFavorite" class="heart-icon">
              <!--&#9825;-->
            </div>
            <div class="share">
              @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                <span (click)="share()" class="sh-btn">
                  <img alt="share" height="100" width="100" loading="lazy" fetchpriority="auto"
                       ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/icons/share.webp">
                </span>
              }
              <!--<span (click)="share()">
              ⤷
            </span>-->
            </div>
          </div>
        </div>
        @if (!compData?.container?.disableBookNow) {
          <div class="dis-wrp">
            @if (compData?.container?.priceDetail?.totalB2bSpecialDiscount > 0) {
              <div class="spl-dis">
                <span class="circle">
                 <!-- <span class="spl-ic"></span>-->
                  <!--<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                       stroke-width="1.5" stroke="currentColor" class="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                  </svg>-->
                  <svg width="12px" height="12px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                          d="M11.566.66a2.189 2.189 0 00-3.132 0l-.962.985a2.189 2.189 0 01-1.592.66l-1.377-.017a2.189 2.189 0 00-2.215 2.215l.016 1.377a2.189 2.189 0 01-.66 1.592l-.984.962a2.189 2.189 0 000 3.132l.985.962c.428.418.667.994.66 1.592l-.017 1.377a2.189 2.189 0 002.215 2.215l1.377-.016a2.189 2.189 0 011.592.66l.962.984c.859.88 2.273.88 3.132 0l.962-.985a2.189 2.189 0 011.592-.66l1.377.017a2.189 2.189 0 002.215-2.215l-.016-1.377a2.189 2.189 0 01.66-1.592l.984-.962c.88-.859.88-2.273 0-3.132l-.985-.962a2.189 2.189 0 01-.66-1.592l.017-1.377a2.189 2.189 0 00-2.215-2.215l-1.377.016a2.189 2.189 0 01-1.592-.66L11.566.66zM7 8.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm.778-8.278a1.1 1.1 0 010 1.556l-6 6a1.1 1.1 0 11-1.556-1.556l6-6a1.1 1.1 0 011.556 0z"
                          fill="#FF6B00"/>
                  </svg>
                </span>
                <span>{{ compData?.container?.newCartDescription?.presentationData?.b2bSpecialDiscountInfo }}</span>
              </div>
            }
            @if (compData?.container?.priceDetail?.membershipDiscount > 0) {
              <div class="spl-dis">
                <span class="circle">
                  <!--<span class="spl-ic"></span>-->
                  <svg width="12px" height="12px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                          d="M11.566.66a2.189 2.189 0 00-3.132 0l-.962.985a2.189 2.189 0 01-1.592.66l-1.377-.017a2.189 2.189 0 00-2.215 2.215l.016 1.377a2.189 2.189 0 01-.66 1.592l-.984.962a2.189 2.189 0 000 3.132l.985.962c.428.418.667.994.66 1.592l-.017 1.377a2.189 2.189 0 002.215 2.215l1.377-.016a2.189 2.189 0 011.592.66l.962.984c.859.88 2.273.88 3.132 0l.962-.985a2.189 2.189 0 011.592-.66l1.377.017a2.189 2.189 0 002.215-2.215l-.016-1.377a2.189 2.189 0 01.66-1.592l.984-.962c.88-.859.88-2.273 0-3.132l-.985-.962a2.189 2.189 0 01-.66-1.592l.017-1.377a2.189 2.189 0 00-2.215-2.215l-1.377.016a2.189 2.189 0 01-1.592-.66L11.566.66zM7 8.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm.778-8.278a1.1 1.1 0 010 1.556l-6 6a1.1 1.1 0 11-1.556-1.556l6-6a1.1 1.1 0 011.556 0z"
                          fill="#FF6B00"/>
                  </svg>
                </span>
                <span>{{ compData?.container?.newCartDescription?.presentationData?.memberDiscountInfo }}</span>
              </div>
            }
          </div>
          <!-- Redeem Credit Point Card Starts -->
          @if (compData?.container?.promotionData?.redeemCreditPointCard?.isCreditPointApplicable) {
            <div class="cdt-dis">
              <span class="coin-img">
                @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                  <img
                    [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/coin-rupee.png' + '?format=webp&quality=90'"
                    alt="coin" width="18" height="18">
                }
                </span>
              <span class="title">{{ compData?.container?.promotionData?.redeemCreditPointCard?.title }}</span>
            </div>
          }
          <!-- Redeem Credit Point Card Ends -->
        }
      </div>
    </div>
    @if (compData?.container?.disableBookNowMessage) {
      <div class="err-msg">
        {{ compData?.container?.disableBookNowMessage }}
      </div>
    }
  </div>
</ng-template>
